import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

const INIT_STATE = {
  password: '',
  password_confirmation: '',
  current_password: '',
};

function ChangePasswordModal({
  updating,
  taxpayerId,
  changePassword,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(INIT_STATE);

  const validateForm = useFormValidator(formData, {
    current_password: 'required|password',
    password: 'required|not_match:current_password|password',
    password_confirmation:
      'required|not_match:current_password|match:password|password',
  });

  const updateData = () => {
    showTransaction(taxpayerId);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    changePassword(taxpayerId, formData, () => {
      setModal({ isOpen: false });
      updateData();
    });
  };

  const OnSetFormData = () => {
    setFormData({
      password: '',
      password_confirmation: '',
      current_password: '',
    });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    OnSetFormData();
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mx-auto">
          <div className="col-12 form-group">
            <label className="form-label">
              Current Password: {validateForm.renderMessage('current_password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="current_password"
              placeholder="Current Password"
              value={_.get(formData, 'current_password')}
              onChange={onChange}
            />
          </div>

          <div className="col-12 form-group">
            <label className="form-label">
              New Password: {validateForm.renderMessage('password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password"
              placeholder="New Password"
              value={_.get(formData, 'password')}
              onChange={onChange}
            />
          </div>

          <div className="col-12 form-group">
            <label className="form-label">
              Re-type New Password:{' '}
              {validateForm.renderMessage('password_confirmation')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password_confirmation"
              placeholder="Re-type New Password"
              value={_.get(formData, 'password_confirmation')}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-3 "
          >
            <span className="font-weight-bold">Close</span>
          </button>
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              formData.password !== formData.password_confirmation
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
ChangePasswordModal.propTypes = {
  taxpayerId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  //   history: PropTypes.instanceOf(Object).isRequired,
  changePassword: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CHANGE_PASSWORD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ChangePasswordModal);
